/**
 * Loyalty rewards
 */

import {assetFromRef,fbLogin} from '../utils/utils';

export default (function() {

    var ItemModel, ItemView, ItemList, ComponentView;

    ItemModel = Backbone.Model.extend();

    ItemView = Backbone.View.extend({
        // TODO: tagname should probably be configurable ;)

        initialize: function(o) {
            this.template = o.template;
            _.bindAll(this,'followTarget','showDetails');
        },
        render: function() {
            var obj = this.model.attributes,
                type = this.model.get('itemClass');
            // decode asset ref urls for rendering
            if (obj.assets) {
                if ( obj.assets.main )       obj.badgeSrc = assetFromRef( obj.assets.main, NGX.context ).src;
                if ( obj.assets.thumbnail )  obj.badgeThumb = assetFromRef( obj.assets.thumbnail, NGX.context ).src;
                if ( obj.assets.background ) obj.badgeBg = assetFromRef( obj.assets.background, NGX.context ).src;
            }

            obj.type = type.replace("type.campaignpromotion.reward.","");

            var html = this.template( obj );
            this.setElement( $( html.trim() ) );

            //if (type === 'type.campaignpromotion.reward.badge') {
            // get the badge
            var $badge  = this.$el;
            // granted
            if ($badge.hasClass('xStatusGranted')) {
                this.$el.on('click', this.followTarget);
            }
            // unlocked
            else if ($badge.hasClass('xStatusAvailable')&&$badge.hasClass('xStatusUnlocked')) {
                if (obj.itemOpts.renderMode === 'xRenderOverlay') {
                    this.$el.on('click', this.showDetails);
                } else {
                    this.$el.on('click', this.followTarget);
                }
            }

            //}

            return this;
        },
		// Redirect to external URL
        followTarget : function(e) {
            var thisLink = this.$('a.xBadgeDetailsLink');
            if ( thisLink.length > 0 ) {
                e.preventDefault();
                var url  = thisLink.attr('href');
                // try to simulate rel=noreferrer for FB mobile
                if (v4.isMobile()) {
                    var a = document.createElement('a'),
                        triggerUIEvent = function(eventName) {
                            var uiEvent = document.createEvent('UIEvent');
                            uiEvent.initUIEvent(eventName, true, true);
                            return this.dispatchEvent(uiEvent);
                        };
                    a.setAttribute('rel','noreferrer');
                    a.setAttribute('href', url);
                    a.setAttribute('target', thisLink.attr('target'));
                    // BUGFIX: for Android's default browser we need to trigger the events in a very specific order for this to work.
                    triggerUIEvent.call(a, 'touchstart');
                    triggerUIEvent.call(a, 'click');
                }
                // otherwise we can just open the window
                else window.open( url );
            }
        },
        // show details overlay for a reward item
        showDetails: function(e) {
            e.preventDefault();
            NGX.overlay.create({
                content  : this.model.attributes,
                template : NGX.App.api.getTemplate('overlayMediacard')
            });
        }
    });

    ItemList = Backbone.Collection.extend({
        // url parameters are taken from NGX.context and handled by the fetch
        url   : '/display/gamification/rewards.json',
        model : ItemModel
    });

    ComponentView = Backbone.View.extend({
        initialize: function() {
            var _self = this;
            _.bindAll( this, 'createCollection', 'storeJson', 'addAll', 'addItem' );
            // TODO: the xRewardsList and xRewardRow prefixes should be set in the component model on app:ready so this is more agnostic
            this.$list = $( '#xRewardsList_' + this.el.id + ' .xContainerInner' );

            // as soon as we have an FB id get the rewards list, then update the model
            if (NGX.App.state.currentUser.fbid) {
                this.createCollection( 'items' );
            } else {
                NGX.App.Events.on('fb:ready', function(){
                    fbLogin( _self.createCollection.bind(this, 'items'), { timing: 'now', scope:''} );
                });
            }
        },
        // create a named collection within this view
        createCollection: function(name) {
            var list = this[name] = new ItemList({
                el: this.$list
            });
            this.listenTo(list, 'reset', this.addAll);
            this.listenTo(list, 'add', this.addItem);
            list.fetch({
                success: this.storeJson,
                data: {
                    apikey     : NGX.context.apikey,
                    campaignId : NGX.App.config.id,
                    fbid       : NGX.App.state.currentUser.fbid,
                    typeRef    : 'type.campaignpromotion.reward.badge',
                    cID        : NGX.App.config.id
                }
            });
        },
        // storeJson is used for list item sharing
        storeJson: function(collection, response) {
            this.model.set('response', response.content);
        },
        // build & render views for a whole collection
        addAll: function(collection) {
            _.each(collection.models, function(model) {
                this.addItem( model )
            }, this);
        },
        // build and render an item view from its model
        addItem: function(model) {
            var obj = {
                model: model,
                template: NGX.App.api.getTemplate(this.model.get('template'))
            };
            obj.model.set('itemOpts',this.model.get('itemOpts'));
            this.$list.append( new ItemView( obj ).render().el );
        }
    });

    // register new view against a component type
    NGX.comps.push({type:'incentives',  view:ComponentView});

}());